module.exports = __webpack_public_path__ + "img/banner3.3b66eb34.png";